<script>
import axios from "axios";

// axios.defaults.baseURL = "http://127.0.0.1:8000/api";
axios.defaults.baseURL = 'https://admin.namirembedioceseyoungchristiansacco.com/api';

const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
} else {
  axios.defaults.headers.common["Authorization"] = "";
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
}
import appConfig from "@/app.config";
export default {
  name: "app",
  page: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },

  data() {
    return {
      toastShown: false,
    }
  },
  mounted() {
    this.checkForUnauthorization();
    this.checkLicense();
  },

  methods: {
    checkLicense() {
      const active_license = localStorage.getItem('active_license')
      if (active_license == 0) {
        this.$router.push('/expired-license');
        if (active_license == 0) {
          this.$router.beforeEach((to, from, next) => {
            next(false);
          });
        }
      }
    },

    handleUnauthorizedError() {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      this.$router.push('/login');
      this.$toast.warning("Session expired, please login again");
      this.toastShown = true;
      setTimeout(() => {
        this.toastShown = false;
      }, 10000);
    },

    async checkForUnauthorization() {
      await axios.interceptors.response.use(
        response => response,
        error => {
          if (error.response.status === 401 && !this.toastShown) {
            this.handleUnauthorizedError();
          }
          return Promise.reject(error);
        }
      );
    }
  }
}
</script>

<template>
  <div id="app">
    <RouterView />
    <Toasts :rtl="true" :max-messages="7" :showProgress="false" :time-out="5000" :closeable="false"></Toasts>
  </div>
</template>
